/* IntelApps — Homepage */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import HomeHero from '../parts/Hero.js';
import StatsBand from '../parts/Stats.js';
import ServicesGrid from '../parts/Service.js';
import ProcessSection from '../parts/Process.js';
import HomeWorkSlider from '../parts/HomeWorkSlider.js';
import CustomerTestimonials from '../parts/CustomerTestimonials.js';
import WhyChooseUs from '../parts/WhyChooseUs.js';
import DiscussCTA from '../parts/Discuss.js';

export default function HomePage() {
  useEffect(() => { document.title = 'IntelApps — Production-ready AI products in 12 weeks'; }, []);

  return (
    <>
      <Header />
      <main>
        <HomeHero />
        <HomeWorkSlider />
        <CustomerTestimonials />
        <ServicesGrid showTeaser />
        <StatsBand />
        <WhyChooseUs />
        <ProcessSection />
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
